import { call, delay, takeLatest, put, select } from "redux-saga/effects";
import * as profileCardActions from "../actions/profileCard";
import {
  getEmployeeRequest,
  updateEmployeeRequest,
  createEmployeeRequest,
  updateEmployeeStatusRequest,
  getCheckUserByPhoneNumberRequest
} from "../../api/profileCard";
import { dataAdjustmentErrorResponse } from "../../api/profileCard/dataAdjustment";
import { errorProcessing } from "../../api/errorProcessing";
import showSuccessWindow from "../../../../common/components/successPopup/successPopup";
import {
  successEditProfile,
  successCreateProfile,
  successUpdateStatus
} from "../../components/ProfileCard/popup/success";
import history from "../../../../common/history";
import { message } from "antd";

const getUserId = state => {
  return (
    state.Authorization &&
    state.Authorization.user &&
    state.Authorization.user.id
  );
};

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

const getFullName = data => {
  return (
    `${data.lastname} ${data.name}` +
    (data.patronymic ? ` ${data.patronymic}` : "")
  );
};

function* getEmployeeSaga(action) {
  let userId = yield select(getUserId);
  let activeProfileId = yield select(getActiveProfileId);
  if (userId && activeProfileId) {
    try {
      const response = yield call(
        getEmployeeRequest,
        activeProfileId,
        action.payload
      );
      yield put(profileCardActions.getEmployeeSuccess(response));
    } catch (err) {
      yield put(profileCardActions.getEmployeeError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    userId = yield select(getUserId);
    activeProfileId = yield select(getActiveProfileId);
    userId && activeProfileId
      ? yield put(profileCardActions.getEmployee(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* updateEmployeeSaga(action) {
  const userId = yield select(getUserId);
  const activeProfileId = yield select(getActiveProfileId);
  if (userId && activeProfileId) {
    try {
      const response = yield call(
        updateEmployeeRequest,
        activeProfileId,
        action.payload
      );
      yield put(profileCardActions.updateEmployeeSuccess(response));
      showSuccessWindow(successEditProfile(getFullName(response.data)));
    } catch (err) {
      let errData = errorProcessing(err, dataAdjustmentErrorResponse);
      yield put(profileCardActions.updateEmployeeError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* createEmployeeSaga(action) {
  const userId = yield select(getUserId);
  const activeProfileId = yield select(getActiveProfileId);
  if (userId && activeProfileId) {
    try {
      const response = yield call(
        createEmployeeRequest,
        activeProfileId,
        action.payload
      );
      yield put(profileCardActions.createEmployeeSuccess(response));
      showSuccessWindow(successCreateProfile(response.data.role));
      history.push("/employees");
    } catch (err) {
      let errData = errorProcessing(err, dataAdjustmentErrorResponse);
      yield put(profileCardActions.createEmployeeError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* updateEmployeeStatusSaga(action) {
  const userId = yield select(getUserId);
  const activeProfileId = yield select(getActiveProfileId);
  if (userId && activeProfileId) {
    try {
      const response = yield call(
        updateEmployeeStatusRequest,
        activeProfileId,
        action.payload
      );
      yield put(profileCardActions.updateEmployeeStatusSuccess(response));
      showSuccessWindow(
        successUpdateStatus(
          getFullName(response.data),
          response.data.profileStatusKey
        )
      );
      history.push("/employees");
    } catch (err) {
      let errResult = {
        data: null,
        message: err.message,
        statusCode: null
      };
      if (err.response) {
        errResult.statusCode = err.response.status;
        if (err.response.status === 400) {
          errResult.data = dataAdjustmentErrorResponse
            ? dataAdjustmentErrorResponse(err.response.data)
            : err.response.data;
          errResult.message =
            err.response.data && err.response.data.message
              ? err.response.data.message
              : "Ошибка";
        } else if (err.response.status === 404) {
          errResult.message = "Страница не найдена";
        } else if (err.response.status === 403) {
          if (
            err.response.data &&
            err.response.data.error &&
            err.response.data.error.access
          ) {
            errResult.message =
              "Сотрудника или ТС нельзя архивировать, так как они участвуют не в архивных заказах и/или предложениях";
          } else if (
            err.response.data &&
            err.response.data.message === "This action is unauthorized."
          ) {
            errResult.message = "У вас недостаточно прав";
          } else if (err.response.data && err.response.data.message) {
            errResult.message = err.response.data.message;
          } else {
            errResult.message = "Ошибка доступа";
          }
        }
      }
      message.error(errResult.message);
      yield put(profileCardActions.updateEmployeeStatusError(errResult));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* getCheckUserByPhoneNumberSaga(action) {
  try {
    const response = yield call(
      getCheckUserByPhoneNumberRequest,
      action.payload
    );
    yield put(profileCardActions.getCheckUserByPhoneNumberSuccess(response));
  } catch (err) {
    let errData = errorProcessing(err, dataAdjustmentErrorResponse);
    yield put(
      profileCardActions.getCheckUserByPhoneNumberError({
        phone: action.payload,
        err: errData
      })
    );
  }
}

export function* profileCardConfigWatcher() {
  yield takeLatest(profileCardActions.getEmployee.toString(), getEmployeeSaga);
  yield takeLatest(
    profileCardActions.updateEmployee.toString(),
    updateEmployeeSaga
  );
  yield takeLatest(
    profileCardActions.createEmployee.toString(),
    createEmployeeSaga
  );
  yield takeLatest(
    profileCardActions.updateEmployeeStatus.toString(),
    updateEmployeeStatusSaga
  );
  yield takeLatest(
    profileCardActions.getCheckUserByPhoneNumber.toString(),
    getCheckUserByPhoneNumberSaga
  );
}
